@if ($allowBrushModeSelection()) {
    <div class="cm-move-modes">
        <cm-button class="cm-move-mode" [class.cm-active]="$brushMode() === BrushMode.Add" (click)="setBrushMode(BrushMode.Add)" [disabled]="$disabled()">
            <ng-container cm-left-icon><i class="far fa-plus"></i></ng-container>
            <ng-container cm-text>Add</ng-container>
        </cm-button>
        <cm-button
            class="cm-move-mode"
            [class.cm-active]="$brushMode() === BrushMode.Subtract"
            (click)="setBrushMode(BrushMode.Subtract)"
            [disabled]="$disabled()"
        >
            <ng-container cm-left-icon><i class="far fa-minus"></i></ng-container>
            <ng-container cm-text>Subtract</ng-container>
        </cm-button>
    </div>
}
<div>
    <span class="cm-label">Size</span>
    <cm-slider [min]="1" [max]="1000" [exponent]="4" [(value)]="$brushSettings().width" [disabled]="$disabled()"></cm-slider>
</div>
<div>
    <span class="cm-label">Hardness</span>
    <cm-slider [min]="0" [max]="1" [(value)]="$brushSettings().hardness" [disabled]="$disabled()"></cm-slider>
</div>
